// extracted by mini-css-extract-plugin
export default {"container":"Shower_container__plcou","image":"Shower_image__lZ1mR","title":"Shower_title__g6IA8","text_box":"Shower_text_box__cbOzb","btn":"Shower_btn__0axas"};